import { Helmet } from "react-helmet";
import React, { Component } from "react";
import "../../styles/groups/groups.scss";
import ShowEntries from "../commoncomponents/ShowEntries";
import Search from "../commoncomponents/Search";
import { Button } from "react-bootstrap";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import queryString from "query-string";
import { encodeQueryData } from "../../api/apiClient";
import Paginations from "../commoncomponents/pagination";
import GroupTable from "./groupTable";
import ShowingResults from "../commoncomponents/showingResults";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";

class Groups extends Component {
  // /api/Group/GetAllGroup

  constructor(props) {
    super(props);
    this.state = {
      GroupList: [],
      searchKey: "",
      pageCount: 0,
      //states for showing entries and total entries in page
      totalEntry: 0,
      entryStart: "1",
      entryEnd: "50",
      totalFilter: false,
      totalEntryFilter: "",
      filterMessage: false,
    };
    this.searchText = "";
    this.customerId = "";
    this.pageSize = "50";
    this.pageKey = "1";
    this.sortDirection = "asc";
    this.sortString = "customer";
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    var urlAll = "";
    if (values.customerId) {
      this.customerId = values.customerId;
      let query = encodeQueryData(this.setGroupQueryObject());
      urlAll = `${apiHost}/api/Group/GetAllGroup?${query}`;
      this.getGroups(urlAll);
    } else {
      let query = encodeQueryData(this.setGroupQueryObject());

      urlAll = `${apiHost}/api/Group/GetAllGroup?${query}`;
      this.getGroups(urlAll);
    }
  }

  handleShowEntries = (inputShowEntries) => {
    console.log(inputShowEntries);
    this.pageSize = inputShowEntries;
    let query = encodeQueryData(this.setGroupQueryObject());
    let urlAll = `${apiHost}/api/Group/GetAllGroup?${query}`;
    this.getGroups(urlAll);
  };

  handleSearch = (inputSearch) => {
    //filtered by message on showing results
    if (inputSearch == "") {
      this.setState({ filterMessage: false });
    } else {
      this.setState({ filterMessage: true });
    }
    this.searchText = inputSearch;
    let query = encodeQueryData(this.setGroupQueryObject());
    let urlAll = `${apiHost}/api/Group/GetAllGroup?${query}`;
    this.getGroups(urlAll);
  };

  handleSort = (name, order) => {
    this.sortString = name;
    this.sortDirection = order;
    console.log("name", this.sortString, "order", this.sortDirection);
    let query = encodeQueryData(this.setGroupQueryObject());
    let urlAll = `${apiHost}/api/Group/GetAllGroup?${query}`;
    this.getGroups(urlAll);
  };

  setGroupQueryObject = () => {
    let data = {};
    data.SearchString = this.searchText;
    data.customerId = this.customerId;
    data.PageSize = this.pageSize;
    data.PageNumber = this.pageSize == 1000000 ? 1 : this.pageKey;
    data.SortDirection = this.sortDirection;
    data.SortString = data.SortString = this.customerId ? "name" : this.sortString;;
    return data;
  };

  handlePagination = (page) => {
    this.pageKey = page;
    let query = encodeQueryData(this.setGroupQueryObject());
    let urlAll = `${apiHost}/api/Group/GetAllGroup?${query}`;
    this.getGroups(urlAll);
  };

  getGroups = async (url) => {
    this.props.setErrorMessageAction("");
    this.props.setLoadingPageAction(true);
    try {
      let GroupList = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({
        GroupList: GroupList.data,
        pageCount: JSON.parse(GroupList.headers.pagination).totalPages,
      });
      this.handleShowResults(GroupList);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);
    }
  };

  handleShowResults = (response) => {
    // function for showing entries and total entries in page

    this.setState({
      totalEntry: JSON.parse(response.headers.pagination).totalItems,
    });
    if (!this.state.totalFilter) {
      this.setState({
        totalEntryFilter: JSON.parse(response.headers.pagination).totalItems,
        totalFilter: true,
      });
    }
    this.setState({
      entryStart: parseInt(this.pageSize) == 1000000 ? 1 : (parseInt(this.pageKey) - 1) * parseInt(this.pageSize) + 1,
    });
    if (
      JSON.parse(response.headers.pagination).totalItems <
      parseInt(this.state.entryEnd)
    ) {
      this.setState({
        entryEnd: JSON.parse(response.headers.pagination).totalItems,
      });
    } else {
      let value =
        parseInt(JSON.parse(response.headers.pagination).currentPage) *
        parseInt(this.pageSize);
      this.setState({ entryEnd: value });
    }
    if (
      this.state.entryEnd >
      parseInt(JSON.parse(response.headers.pagination).totalItems)
    ) {
      this.setState({
        entryEnd: JSON.parse(response.headers.pagination).totalItems,
      });
    }
    if (this.state.GroupList == "") {
      this.setState({ entryStart: "0", entryEnd: "0", totalEntry: "0" });
    }
  };

  handleCreateNew = () => {
    const values = queryString.parse(this.props.location.search);
    if (values.customerName) {
      this.props.history.push(
        `/create-new-group?selectedAsset=${values.customerName}&customerId=${values.customerId}`
      );
    } else {
      this.props.history.push(`/create-new-group`);
    }
  };

  render() {
    const arr = [50, 100, 150, 200, 1000000];
    const values = queryString.parse(this.props.location.search);

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>All groups </title>
          </Helmet>

          <div className="contentBody">
            <div className="contentWrapper">
              <h2>
                All Groups
                {values.customerId && (
                  <small>
                    {`filtered by customerName `}
                    <a
                      onClick={() => localStorage.removeItem("customer")}
                      href="/groups"
                    >
                      <span>
                        <i className=" fa fa-times"></i>
                        {values.customerName}
                      </span>
                    </a>
                  </small>
                )}
              </h2>

              <Button variant="primary" onClick={() => this.handleCreateNew()}>
                Create New
              </Button>

              <div className="inline">
                <ShowEntries
                  showEntriesCallback={this.handleShowEntries}
                  data={arr}
                />
                <Search searchCallback={this.handleSearch} />
              </div>
              <div className="groupTable">
                <GroupTable
                  GroupList={this.state.GroupList}
                  sortFunction={this.handleSort}
                />
              </div>
              <div className="paginationDetails">
                <ShowingResults
                  currentEntryStart={this.state.entryStart}
                  currentEntryEnd={this.state.entryEnd}
                  totalEntries={this.state.totalEntry}
                  totalFilterEntries={this.state.totalEntryFilter}
                  filterMessage={this.state.filterMessage}
                />
                <Paginations
                  pageCount={this.state.pageCount}
                  pageRange={5}
                  onPagination={this.handlePagination}
                ></Paginations>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Groups);
